import { useMemo } from "react";
import { useApi } from "./Api";

export const useOnboardingCheck = async (): Promise<boolean> => {
    const api = useApi();

    return useMemo(async () => {
        let onboarded = false;
        try {
            const response = await api.get("/api/profile/IsOnboarded");
            onboarded = (response.data === true);
        } catch {
            console.error("Failed to check user onboarded");
        }

    return onboarded;

  }, [api]);
}
